import { StyleSheet } from 'react-native';
import { Colors, SharedUnvalidatedStyles } from '@shared/styles';

export const Styles = StyleSheet.create({
  root: {
    width: '100%',
  },
  image: {
    width: 44,
    height: 44,
  },
  imageMargin: {
    marginRight: 16,
  },
  imageRound: {
    borderRadius: 22,
    overflow: 'hidden',
  },
  imageWithShadow: {
    ...SharedUnvalidatedStyles.shadow,
    width: 44,
    height: 44,
    borderRadius: 22,
    overflow: 'hidden',
    borderWidth: 3,
    borderColor: 'white',
    zIndex: 10,
  },
  dotContainer: {
    borderRadius: 10,
    width: 20,
    height: 20,
    padding: 0,
  },
  deselectedDotContainer: {
    borderColor: Colors.gray.border,
    borderWidth: 1,
  },
  selectedDotContainer: {
    borderColor: Colors.v2.green,
    borderWidth: 2,
  },
  selectedDotInside: {
    width: 10,
    height: 10,
    borderRadius: 5,
    backgroundColor: Colors.v2.green,
  },
  highlight: {
    ...SharedUnvalidatedStyles.borderRadius,
    marginHorizontal: 4,
    marginVertical: 1,
    overflow: 'hidden',
  },
});
